import React, { Component, useState } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
  Modal,
  Button,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import _ from "lodash";

import AddReceiptLinePalletsGrid from "./AddReceiptLinePalletsGrid.jsx";
import ReceiptLinePalletEditorModel from "./viewModels/ReceiptLinePalletEditorModel.js";


function isNormalInteger(val) {
  var n = Math.floor(Number(val));
  return n !== Infinity && String(val) === val && n >= 0;
}

export default class AddReceiptLinePalletEditorModal extends Component {
  // props - this.prop.receiptLine
  constructor(props) {
    super(props);
    this.gcidInput = React.createRef();
    this.state = {
      pallets: [],
      actualPalletUnitQty: 0,
      aggregateLineQty: 0,
      diffLineQty: 0,
      diffColor: "yellow",
      currentSelectedPallet: null,
      errMsg: "",
      diffUnitQty: 0
    };

    this.initDialog = this.initDialog.bind(this);

    this.onRequestSaveForm = this.onRequestSaveForm.bind(this);
    this.onRequestCancelForm = this.onRequestCancelForm.bind(this);
    this.onRequestClearForm = this.onRequestClearForm.bind(this);

    this.onActualQtyEvent = this.onActualQtyEvent.bind(this);
    this.onGlasschainIdBlurEvent = this.onGlasschainIdBlurEvent.bind(this);
    this.onRequestRemovePallet = this.onRequestRemovePallet.bind(this);
    this.onRequestAddPallet = this.onRequestAddPallet.bind(this);

    this.onPalletSelectionChange = this.onPalletSelectionChange.bind(this);


  }


  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.showLinePalletEditor !== "undefined" &&
      this.props.showLinePalletEditor &&
      !prevProps.showLinePalletEditor
    ) {
      this.initDialog();
    }
  }

  initDialog() {
    // "clone" the pallets, so if user cancels, we are not mutating the original. On save, we can post back these.
    var clonedCurrentReceiptLine = _.clone(this.props.receiptLine);
    console.log("Cloned Receipt Line: ");
    console.log(clonedCurrentReceiptLine);
    this.setState({
      actualPalletUnitQty: this.props.receiptLine.itemPalletDefaultCubeQty,
      diffLineQty: this.props.receiptLine.tagLineQty,
      pallets: clonedCurrentReceiptLine.pallets
    });
    var aggQtyInfo = this.recalcAggQtyInfo(
      clonedCurrentReceiptLine.pallets,
      clonedCurrentReceiptLine.tagLineQty
    );
    this.setState({
      aggregateLineQty: aggQtyInfo.aggrQty,
      diffLineQty: aggQtyInfo.diffQty,
      diffColor: aggQtyInfo.diffColor,
    });

    if(this.props.receiptLine.tagLineQty < this.props.receiptLine.itemPalletDefaultCubeQty){
      this.setState({
        actualPalletUnitQty: this.props.receiptLine.tagLineQty
      })
    } else {
      this.setState({
        actualPalletUnitQty: this.props.receiptLine.itemPalletDefaultCubeQty
      })
    }
  }


  onPalletSelectionChange(selectedPallet) {
    this.setState({ currentSelectedPallet: selectedPallet });
  }


  onRequestSaveForm() {
    //this.props.onAddReceiptPalletLine(this.state.palletEditor);
    this.props.onAddPallets(this.state.pallets);
    this.props.onRequestLinePalletEditorDialogClose();

  }

  onRequestCancelForm() {
    this.setState({ lineEditor: new ReceiptLinePalletEditorModel() });
    this.props.onRequestLinePalletEditorDialogClose();
  }
  onRequestClearForm() {
  }

  onRequestAddPallet(ev) {
    if (this.state.diffLineQty < this.props.receiptLine.itemPalletDefaultCubeQty && this.state.diffLineQty >= 0) {
      this.setState({
        actualPalletUnitQty: this.state.diffLineQty
      })
    } else {
      this.setState({
        actualPalletUnitQty: this.props.receiptLine.itemPalletDefaultCubeQty
      })
    }
  }

  onRequestRemovePallet() {
    if (!this.state.currentSelectedPallet) {
      alert("Please select a pallet before trying to delete.");
      return;
    }
    var myNewPallets = this.state.pallets.filter(pallet => pallet.glasschainId !== this.state.currentSelectedPallet.glasschainId);
    this.setState({ pallets: myNewPallets });
    var aggQtyInfo = this.recalcAggQtyInfo(
      myNewPallets,
      this.props.receiptLine.tagLineQty
    );
    var actualQty = Math.min(parseInt(this.props.receiptLine.itemPalletDefaultCubeQty), parseInt(aggQtyInfo.diffQty));
    this.setState({
      aggregateLineQty: aggQtyInfo.aggrQty,
      diffLineQty: aggQtyInfo.diffQty,
      diffColor: aggQtyInfo.diffColor,
      actualPalletUnitQty: actualQty
    });

  }

  onActualQtyEvent(ev) {
    var val = ev.target.value;
    if (!isNormalInteger(val)) {
      alert("Please enter a positive number!");
      return;
    }
    var valInt = parseInt(val);
    this.setState({
      actualPalletUnitQty: valInt
    });
    // this.onRequestAddPallet(ev)
  }



  onGlasschainIdBlurEvent(ev) {
    if (ev.target.value === "") return; // don't allow blanks.
    if (ev.target.value.length > this.props.maxMraTagLength)
    {
      this.gcidInput.current.focus();
      ev.target.select();
      this.setState({ errMsg: ev.target.value + " is too long. Maximum length is " + this.props.maxMraTagLength });
      return; // don't allow dupes.  
    }

    var myPallets = this.state.pallets;
    if (myPallets.some((m) => m.glasschainId === ev.target.value)) 
    {
      this.gcidInput.current.focus();
      ev.target.select();
      this.setState({ errMsg: ev.target.value + " has already been attached to this receipt!" });
      return; // don't allow dupes.
    }
    if (this.props.onDupeGlasschainId(ev.target.value, this.props.receiptLine.lineId))
    {
      this.gcidInput.current.focus();
      ev.target.select();
      this.setState({ errMsg: ev.target.value + " has already been used on a different line on this receipt!" });
      return; // don't allow dupes.
  }

    // changing from unshift to push so the sort order of pallets is LILO
    myPallets.push(
      new ReceiptLinePalletEditorModel(
        ev.target.value,
        this.state.actualPalletUnitQty
      )
    );
    // clear out the pallet entry for the next entry
    this.gcidInput.current.value = "";
    this.gcidInput.current.focus();
    this.setState({
      errMsg: "",
      pallets: myPallets,
    });

    var aggQtyInfo = this.recalcAggQtyInfo(
      myPallets,
      this.props.receiptLine.tagLineQty
    );

    var actualQty = Math.min(parseInt(this.props.receiptLine.itemPalletDefaultCubeQty), parseInt(aggQtyInfo.diffQty));
    this.setState({
      aggregateLineQty: aggQtyInfo.aggrQty,
      diffLineQty: aggQtyInfo.diffQty,
      diffColor: aggQtyInfo.diffColor,
      actualPalletUnitQty: actualQty
    });
  }

  recalcAggQtyInfo(pallets, tagLineQty) {
    var aggQty = pallets.reduce(
      (agg, incr) => agg + incr.actualPalletUnitQty,
      0
    );
    var diffQty = tagLineQty - aggQty;
    var diffColor = "green";
    if (diffQty < 0) {
      diffColor = "red";
    } else if (diffQty > 0) {
      diffColor = "yellow";
    }
    var result = { aggrQty: aggQty, diffQty: diffQty, diffColor: diffColor };
    return result;
  }

  makeInputGroup(id, labelText, defaultValue, placeholder, readOnly = true) {

    return (
      <span>
        <label>{labelText}</label>
        <InputGroup>
          <FormControl
            readOnly={readOnly}
            id={id}
            defaultValue={(defaultValue) ? defaultValue : ""}
            placeholder={placeholder ? placeholder : defaultValue}
          />
        </InputGroup>
      </span>
    );
  }

  render() {

    if (this.state.dataReady) {
      console.log('update pallet dialog grid');
      console.log((this.state.pallets) ? this.state.pallets : []);
      this.gridApi.setRowData((this.state.pallets) ? this.state.pallets : []);
    }

    return (
      <Modal
        show={this.props.showLinePalletEditor}
        onHide={this.props.onRequestLinePalletEditorDialogClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Line Pallet Editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                {this.makeInputGroup(
                  "itemName",
                  "Item Name",
                  (this.props.receiptLine) ? this.props.receiptLine.itemName : ""
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {this.makeInputGroup(
                  "lineNbr",
                  "Line#",
                  (this.props.receiptLine) ? this.props.receiptLine.lineNbr : "0"
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {this.makeInputGroup(
                  "tagLineQty",
                  "Tag Qty",
                  (this.props.receiptLine) ? this.props.receiptLine.tagLineQty : 0
                )}
              </Col>
              <Col>
                <label>Current</label>
                <InputGroup>
                  <FormControl
                    readOnly={true}
                    id="palletAggLineQty"
                    value={this.state.aggregateLineQty}
                  />
                </InputGroup>
              </Col>
              <Col>
                <label>Diff</label>
                <InputGroup>
                  <FormControl
                    style={{ backgroundColor: this.state.diffColor }}
                    readOnly={true}
                    id="palletDiffQty"
                    value={this.state.diffLineQty}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                {this.makeInputGroup(
                  "itemPalletDefaultCubeQty",
                  "Default Unit Qty",
                  (this.props.receiptLine) ? this.props.receiptLine.itemPalletDefaultCubeQty : 0
                )}
              </Col>
              <Col>
                <label>Actual Unit Qty</label>
                <InputGroup>
                  <FormControl
                    readOnly={false}
                    id="palletActualQty"
                    value={
                      this.state.actualPalletUnitQty
                    }
                    type="number"
                    placeholder="Actual Qty on Pallet"
                    onChange={e => this.onActualQtyEvent(e)}

                  />
                </InputGroup>
              </Col>
              <Col>
                <label>MRA Id</label>
                <InputGroup>
                  <FormControl
                    ref={this.gcidInput}
                    readOnly={false}
                    id="glasschainId"
                    defaultValue=""
                    placeholder="Enter MRA Id"
                    onBlur={this.onGlasschainIdBlurEvent}
                  />
                  <Button variant="secondary" onClick={this.onRequestAddPallet}>+</Button>
                </InputGroup>

              </Col>
            </Row>
            <hr />
            <Button variant="secondary" onClick={this.onRequestRemovePallet}>Remove Pallet</Button>
            <AddReceiptLinePalletsGrid
              receiptLinePallets={this.state.pallets}
              onPalletSelectionChange={this.onPalletSelectionChange}
              rowData={(this.state.pallets) ? this.state.pallets : []}
              deltaRowDataMode={true}
              getRowNodeId={(data) => data.glasschainId}
            />
            <div style={{ color: "red" }}>{this.state.errMsg}</div>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.onRequestSaveForm}>
            Save
          </Button>
          <Button variant="secondary" onClick={this.onRequestCancelForm}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={this.onRequestClearForm}>
            Clear
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
